import { useMutation } from '@apollo/client';

import { useParams } from 'react-router-dom';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import UpdateDivertCustomerMutation from '@/graphql/contracts/updateDivertCustomer.mutation.gql';
import GetContractDetailsQuery from '@/graphql/contracts/getContractDetails.query.gql';
import { notificationService } from '@/services/notification/notification.client';
import { UpdateDivertCustomer, UpdateDivertCustomerVariables } from
  '@/graphql/contracts/_generated_/updateDivertCustomer.mutation';
import { UpdateDivertCustomerInputType } from '@/graphql/contracts/_generated_/contracts';

export default function useUpdateDivertCustomer() {
  const { contractId }: { contractId: string } = useParams();
  const [_updateDivertCustomer, { loading, error, called }] =
    useMutation<UpdateDivertCustomer, UpdateDivertCustomerVariables>(
      UpdateDivertCustomerMutation,
      {
        client: apolloClientContracts,
        onError: (err) => notificationService.open({
          title: 'Error',
          text: err.message,
          type: 'danger'
        }),
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: GetContractDetailsQuery,
            variables: {
              contractId,
            }
          }
        ],
      }
    );
  const updateDivertCustomer = (input: UpdateDivertCustomerInputType) => {
    _updateDivertCustomer({
      variables: { input }
    });
  };

  return {
    updateDivertCustomer,
    isLoadingUpdateDivertCustomer: loading,
    errorUpdateDivertCustomer: error,
    isUpdateDivertCustomerWasCalled: called
  } as const;
}
